import { useEffect, useState } from "react";
import stripeLogo from "../../../assets/stripe.png";
import { motion, AnimatePresence } from "framer-motion";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import { REST_API_URL } from "../../../api/config";
import { buildHeaders } from "../../../Auth/AuthHooks/authRouting";
import StepLabel from "@mui/material/StepLabel";
import { useAppSelector, useAppDispatch } from "../../../hooks/redux/useRedux";
import { selectCheckPayment, selectPaymentPlans } from "../../../redux/slices/paymentSlice/PaymentSlice";
import { getPaymentPlansThunk } from "../../../redux/slices/paymentSlice/asyncthunk";
export const Subscription = () => {
  const dispatch = useAppDispatch();
  const [isSwitch, setIsSwitch] = useState(false);
  const [paymentPlanIndex, setPaymentPlanIndex] = useState(0);
  const [loadingStripe, setLoadingStripe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hsActivePlan, setHsActivePlan] = useState(false);
  const paymentCheck = useAppSelector(selectCheckPayment);
  const paymentPlans = useAppSelector(selectPaymentPlans);

  const filteredByPeriod = paymentPlans.filter(
    (p: any) => p.period === (isSwitch ? "Yearly" : "Monthly"),
  );

  const currentUsage = filteredByPeriod[0]?.usage;
  const filteredPlans = filteredByPeriod.filter(
    (p: any) => p.usage === currentUsage,
  );
  const selectedPlan = filteredPlans[paymentPlanIndex] ?? null;

  const selectActivePlan = () => {
    if (!paymentCheck || !filteredPlans[paymentPlanIndex]) return;

    const isActive =
      !!paymentCheck?.stripe_subscription &&
      filteredPlans[paymentPlanIndex].stripe_price_id ===
      paymentCheck?.stripe_subscription;
      
    setHsActivePlan(isActive);
  };

  useEffect(() => {
    selectActivePlan();
  }, [paymentCheck, paymentPlanIndex, isSwitch]);

  const onStripe = async () => {
    try {
      setLoadingStripe(true);
      const token =
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("accessToken");
      const headers = buildHeaders(token);
      const STRIPE_URL = `${REST_API_URL}/payment/stripe-checkout-session/`;
      const res = await fetch(STRIPE_URL, {
        method: "POST",
        body: JSON.stringify({
          stripe_price_id: selectedPlan?.stripe_price_id,
        }),
        headers,
      });
      const data = await res.json();
      window.location.href = data.url;
      setLoadingStripe(false);
    } catch (e) {
      console.log("Stripe error", e);
      setLoadingStripe(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        await dispatch(getPaymentPlansThunk());
      } catch (e) {
        console.log("Failed to init", e);
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  return (
    <div className="  w-full p-4 relative self-center flex flex-col items-center  h-full ">
      <img
        src={stripeLogo}
        className="w-[100px] sm:w-[130px] drop-shadow-xl animate-fadeInUp relative z-10 opacity-95  "
        alt="stripe"
      />
      {loading ? (
        <div className="flex justify-center py-12">
          <div className="w-8 h-8 border-4 border-[#5563F6] border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <>
          <motion.div
            className="flex w-[90%] mt-4 justify-center mb-6 bg-[#EDEEF2] rounded-full p-1 relative"
            layout
          >
            <motion.div
              layout
              transition={{
                type: "spring",
                stiffness: 220,
                damping: 18,
              }}
              className="absolute top-1 bottom-1 w-1/2 rounded-full bg-[#5563F6]"
              style={{ left: isSwitch ? "50%" : "0%" }}
            />

            <motion.button
              whileTap={{ scale: 0.94 }}
              className={`z-10 w-1/2 py-2 text-sm font-medium transition ${
                !isSwitch ? "text-white" : "text-gray-600"
              }`}
              onClick={() => {
                setIsSwitch(false);
                setPaymentPlanIndex(0);
              }}
            >
              Monthly
            </motion.button>

            <motion.button
              whileTap={{ scale: 0.94 }}
              className={`z-10 w-1/2 py-2 text-sm font-medium transition ${
                isSwitch ? "text-white" : "text-gray-600"
              }`}
              onClick={() => {
                setIsSwitch(true);
                setPaymentPlanIndex(0);
              }}
            >
              Yearly
            </motion.button>
          </motion.div>

          <Box sx={{ width: "100%", mt: 2, mb: 4 }}>
            <Stepper
              activeStep={paymentPlanIndex}
              alternativeLabel
              sx={{
                ".MuiStepLabel-label": {
                  color: "#6b7280",
                  fontSize: "0.9rem",
                },
                ".Mui-active .MuiStepLabel-label": {
                  color: "#5563F6 !important",
                  fontWeight: 600,
                },
                ".Mui-completed .MuiStepLabel-label": {
                  color: "#5563F6",
                },
                ".MuiStepIcon-root": { color: "#cdd0e3" },
                ".Mui-active .MuiStepIcon-root": {
                  color: "#5563F6 !important",
                },
                ".Mui-completed .MuiStepIcon-root": {
                  color: "#5563F6 !important",
                },
              }}
            >
              {filteredPlans.map((plan, index) => (
                <Step key={plan.id}>
                  <motion.div
                    whileHover={{ scale: 1.12 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => {
                      setPaymentPlanIndex(index);
                        console.log("i => ", selectedPlan);
                    }}
                    style={{ cursor: "pointer" }}
                    transition={{
                      type: "spring",
                      stiffness: 260,
                      damping: 16,
                    }}
                  >
                    <StepLabel>{plan.name}</StepLabel>
                  </motion.div>
                </Step>
              ))}
            </Stepper>
          </Box>

          {hsActivePlan && (
            <span className="flex items-center gap-2 text-green-600 font-semibold text-base mb-2">
              <span role="img" aria-label="active">
                ✅
              </span>
              You are currently using this plan
            </span>
          )}

          <AnimatePresence mode="wait">
            {selectedPlan && (
              <motion.div
                key={selectedPlan.id}
                initial={{ opacity: 0, y: 20, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -20, scale: 0.98 }}
                transition={{ duration: 0.35, ease: "easeOut" }}
                className="mt-10 flex flex-col sm:flex-row gap-8 items-center"
              >
                <div className="flex-1 flex justify-center items-center min-h-[260px]">
                  <img
                    src={selectedPlan.image}
                    className="w-full h-full object-contain drop-shadow-xl"
                    alt=""
                  />
                </div>

                <div className="flex-1 text-center sm:text-left">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-1 text-start">
                    {selectedPlan.name}
                  </h3>

                  <p className="text-[#5563F6] font-bold text-3xl mb-3 text-start">
                    ${selectedPlan.price}
                  </p>

                  <p className="text-gray-600 text-sm mb-5 leading-relaxed max-w-xs sm:max-w-none mx-auto sm:mx-0 text-start">
                    {selectedPlan.description}
                  </p>

                

                  <ul className="text-gray-700 text-sm space-y-1 mb-6">
                    {(selectedPlan.includs ?? []).map(
                      (i: { id: string; text: string }) => (
                        <li key={i.id} className="flex items-center">
                          <span className="text-[#5563F6] mr-2">•</span>{" "}
                          {i.text}
                        </li>
                      ),
                    )}
                  </ul>

                     

                  <button
                    className={`w-full px-10 py-3 rounded-xl transition font-medium shadow-md hover:shadow-lg 
                      ${
                        hsActivePlan
                          ? "bg-gray-300 text-gray-400 cursor-not-allowed"
                          : "bg-[#5563F6] hover:bg-[#4450D6] text-white cursor-pointer"
                      }
                    `}
                    onClick={onStripe}
                    disabled={hsActivePlan || loadingStripe}
                  >
                    {loadingStripe ? "loading..." : "Continue"}
                  </button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </>
      )}
    </div>
  );
};
